module.exports = __webpack_public_path__ + "assets/retina_ParallelDetailed.3842d0c17897df405f9181a6341b3e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ParallelDetailed.png
// module id = 698
// module chunks = 0